<template>
  <div>
    <div v-if="permissionMap['key126']">
      <Poptip placement="bottom" trigger="click" transfer width="168">
        <span class="limit-text">{{limitNumber}}</span>
        <Icon class="limit-icon" type="android-settings" style="cursor: pointer"></Icon>
        <div slot="content" class="limit-poptip">
          <div>
            <InputNumber :value="limitNumber" :min="0" @on-change="changeLimit"></InputNumber>
            <Button type="primary" size="small" @click="confirmSub">确定</Button>
          </div>
        </div>
      </Poptip>
    </div>
    <div v-else class="limit-no-pms">
      <span class="limit-text">{{limitNumber}}</span>
      <Icon class="limit-icon" type="android-settings"></Icon>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'

  export default {
    name: "render-limit",
    props:{
      limitDay:{
        type:[String,Number]
      }
    },
    data(){
      return{
        limitNumber:0,
      }
    },
    computed:{
      ...mapGetters(['permissionMap'])
    },
    mounted(){
      this.$nextTick(()=>{
        this.limitNumber = this.limitDay
      })
    },
    methods:{
      changeLimit(value){

      },
      confirmSub(){

      }
    }
  }
</script>

<style lang="less">
  .limit-no-pms{
    margin-left:10px;
    display: flex;
    align-items: flex-end;
  }
  .limit-text{
    display: inline-block;
    width:30px;
  }
  .limit-icon{
    font-size:16px;
    cursor: no-drop;
  }
  .limit-poptip{
    width:40px;
    height:40px;
  }
</style>



// WEBPACK FOOTER //
// src/view/home/function/render/render-limit.vue



// WEBPACK FOOTER //
// src/view/home/function/render/render-limit.vue